var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSendRocket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82.408,
    height: 102,
    viewBox: "0 0 82.408 102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740",
    transform: "matrix(-0.719, 0.695, -0.695, -0.719, 58.15, 71.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24679",
    "data-name": "Path 24679",
    d: "M-50.145,82.7c11.308-4.644,20.333-6.677,27.816-11.592A76.125,76.125,0,0,0,3.559,41.741C5.653,37.7-1.8,30.471-3.526,30.968c-9.578,2.755-6.6,10.548-5.51,12.2,1.7,2.655,6.428,4.33,11.283,2.493a31.524,31.524,0,0,0,13.538-8.784c4.172-4.638,7.145-11.873,8.572-16.24,2.942-9,0-20.639,0-20.639",
    transform: "translate(27.798 8.716) rotate(42)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "paper-plane",
    transform: "translate(47.376 5.689) rotate(40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24699",
    "data-name": "Path 24699",
    d: "M3.261-.114V3.566a.595.595,0,0,1-1.074.352L.035.989Z",
    transform: "translate(8.858 14.065)",
    fill: "#e39f0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24700",
    "data-name": "Path 24700",
    d: "M.27.089A.6.6,0,0,1,.891.046L18.74,9.368a.6.6,0,0,1-.083,1.091l-4.962,1.7L3.128,3.119l8.177,9.852L2.989,15.814a.609.609,0,0,1-.192.032.594.594,0,0,1-.589-.507L.027.662A.6.6,0,0,1,.27.089Z",
    transform: "translate(0 0)",
    fill: "#e39f0e"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendRocket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-rocket.3d2ff1a5.svg";
export { ForwardRef as ReactComponent };